export enum MppMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}
